import React, { useEffect, useState } from 'react';
import CheckboxField from '../CheckboxField';
import Model from '../../../../model';
import { observer } from 'mobx-react-lite';

const PairsCheckboxField = ({ workingWithPairsOptions, setWorkingWithPairs, workingWithPairs}) => {
    const [disabled, setDisabled] = useState(false);

    const onChange = (e) => {
        const value = e.target.checked;
        setWorkingWithPairs(value ? value : null);
    }

    useEffect(() => {
        setDisabled(workingWithPairsOptions.length === 1 && workingWithPairsOptions[0] === false);
    }, [workingWithPairsOptions])

    return (
        <CheckboxField className='pair-checkbox' name='pairs' text={'Консультация для пары'} checked={!!workingWithPairs} onChange={onChange} disabled={disabled}/>
    )
}

export default observer(PairsCheckboxField);
